import * as  Moment from 'moment'
import { Address } from './Address';

export class EmployeeLookup{
    constructor(){
        this.Address = new Address();
    }
    FirstName : string;
    LastName : string;
    SSN : string 
    DOB: Moment.Moment;
    Address : Address;
    Email : string;
    PhoneNumber : string;
    Under40 : boolean;
    
    public get DateOfBirth() : Moment.Moment {
        return this.DOB; 
    }
    
    public set DateOfBirth(v : Moment.Moment) {
        this.DOB = v;
        // are they 40? 
        var fortyYearsAgo = Moment().subtract(40,'years');
        this.Under40 = Moment(this.DOB).isAfter(fortyYearsAgo);
    }

    get fullName(){
        return this.FirstName + ' ' + this.LastName;
    }

    isValid(){

        // return (
        //     this.FirstName != null && 
        //     this.LastName  != null && 
        //     this.SSN != null &&
        //     this.SSN.length == 9 &&
        //     this.DOB != null &&
        //     this.Address != null &&
        //     this.City != null &&
        //     this.State != null && 
        //     this.ZipCode != null) ? true : false;
        return true;
    }
}


// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/Models/EmployeeLookup.ts